import { type ReactElement, Suspense } from 'react';
import { useCreateTransactionBasedPortfolioDialogInputSuspenseQuery } from '../../../../../generated/graphql.tsx';
import FormFreeSoloSingleAutocomplete from '../../../../technical/form/FormFreeSoloSingleAutocomplete.tsx';
import Loader from '../../../../technical/Loader/Loader.tsx';
import type { GInputProps } from 'components/technical/inputs/GInput/GInput.props.ts';

const TransactionBasedPortfolioFormFields = ({ width }: { width: GInputProps['width'] }): ReactElement => {
  const { data } = useCreateTransactionBasedPortfolioDialogInputSuspenseQuery();
  return (
    <FormFreeSoloSingleAutocomplete
      name={'tag'}
      options={data.bookkeeping.transactionTags ?? []}
      label={'Transaction tag'}
      width={width}
      newEntryLabel={'New tag'}
      showLabelAboveInput
    />
  );
};

const TransactionBasedPortfolioFieldsContainer = ({ width }: { width: GInputProps['width'] }): ReactElement => {
  return (
    <Suspense fallback={<Loader />}>
      <TransactionBasedPortfolioFormFields width={width} />
    </Suspense>
  );
};

export default TransactionBasedPortfolioFieldsContainer;
